import React, { Fragment, useEffect, useState } from "react";
import "./SupplierHome.scss";
import { Tab, Button, MenuItem, Menu } from "@mui/material";
import Box from "@mui/material/Box";
import SupplierListView from "../SupplierListView/SupplierListView";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext, TabList } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { getSupplierCount } from "../../../services/srmService";
import AddBoxIcon from "@mui/icons-material/AddBox";
import SupplierDashboard from "../SupplierDashboard/SupplierDashboard";
import SkeletonLoader from "../../common/Skeletons/TableSkeleton/TableSkeletonLoader";
import { t } from "i18next";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { primaryColor } from "../../../constants/colorConstants";
import SupplierReport from "../SupplierReport/SupplierReport";

function SupplierHome() {
  const navigate = useNavigate();
  const [value, setValue] = useState("1");
  let [isData, setIsData] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const map: any = {
    "1": "/partners/suppliers/dashboard",
    "2": "/partners/suppliers/list",
    "3": "/partners/suppliers/reports",
  };
  const handleNewClick = (isManual: boolean) => {
    if (isManual) {
      console.log("opening creation screen");
      navigate("/partners/suppliers/create");
    } else {
      navigate("/partners/suppliers/bulk-upload");
    }
  };
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleNewDropDownClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCreation = (isManual?: boolean) => {
    setAnchorEl(null);

    if (isManual != undefined) {
      handleNewClick(isManual);
    }
  };
  let cellColumns = [
    " ",
    "Company Name",
    "Primary Contact",
    "Address",
    "Status",
    "Registration",
  ];

  useEffect(() => {
    if (window.location.pathname == "/partners/suppliers/dashboard") {
      setValue("1");
    } else if (window.location.pathname == "/partners/suppliers/list") {
      setValue("2");
    } else if (window.location.pathname == "/partners/suppliers/reports") {
      setValue("3");
    }

    getSupplierCount()
      .then((res) => {
        if (res.data.count) {
          setIsData(true);
          if (window.location.pathname == "/partners/suppliers") {
            navigate("/partners/suppliers/list");
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [window.location.pathname]);

  const handleChange = (event: React.SyntheticEvent, newValue: any) => {
    navigate(map[newValue]);
  };
  return (
    <div
      style={{ paddingLeft: 30, paddingRight: 30, backgroundColor: "#f5f7fa" }}
      className="min-h-full"
    >
      {isLoading ? (
        <SkeletonLoader type="text" cells={cellColumns} />
      ) : (
        <Fragment>
          {isData ? (
            <TabContext value={value}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  width: "fit-content",
                }}
              >
                <TabList onChange={handleChange} className="pw-supplier-tabs">
                  <Tab
                    value="1"
                    sx={{ fontWeight: value == "1" ? "bold" : "regular" }}
                    label="Dashboard"
                  />
                  <Tab
                    value="2"
                    sx={{ fontWeight: value == "2" ? "bold" : "regular" }}
                    label="List View"
                  />
                  <Tab
                    value="3"
                    sx={{ fontWeight: value == "3" ? "bold" : "regular" }}
                    label="Reports"
                  />
                </TabList>
              </Box>
              <TabPanel value="1">
                <SupplierDashboard />
              </TabPanel>
              <TabPanel value="2">
                <SupplierListView />
              </TabPanel>
              <TabPanel value="3">
                <SupplierReport />
              </TabPanel>
            </TabContext>
          ) : (
            <div className="pw-empty-page flex flex-col h-100v w-full justify-center items-center gap-5">
              <img
                className="pw-no-items"
                src="assets/images/empty.png"
                alt=" "
              />
              <div>{t("Add suppliers/borrowers to get started")}</div>
              <div className="flex">
                <div className="pw-add-new-supplier">
                  <div
                    id="pw-e2e-add-supplierbtn"
                    className="flex gap-1"
                    onClick={(e) => handleNewClick(true)}
                  >
                    <AddBoxIcon className="pw-box-icon" />
                    {t("New")}
                  </div>
                </div>
                <div
                  style={{
                    color: "white",
                    background: primaryColor,
                    borderRadius: "0px 5px 5px 0px",
                    marginLeft: "0.5px",
                  }}
                >
                  <div
                    style={{
                      background: primaryColor,
                      padding: "5px",
                      marginLeft: "0.5px",
                      borderBottomRightRadius: "5px",
                      borderTopRightRadius: "5px",
                    }}
                    className="pw-cursor-pointer"
                    onClick={(e) => handleNewDropDownClick(e)}
                  >
                    <ArrowDropDownIcon
                      className="pw-box-icon"
                      sx={{ borderRight: "black" }}
                    />
                  </div>
                </div>
              </div>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleCreation()}
              >
                <MenuItem onClick={() => handleCreation(false)}>
                  {t("Manual")}
                </MenuItem>
                <MenuItem onClick={() => handleCreation(false)}>
                  {t("Bulk Upload")}
                </MenuItem>
              </Menu>
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
}

export default SupplierHome;
